import { useRef } from 'react';
import { SearchBar } from '@/components/organisms/search-bar/search-bar';
import { SearchBarDefaultValues } from '@/components/organisms/search-bar/search-bar.types';
import Modal, { ModalProps } from '@/components/utilities/modal/modal';
import { FloatingPortalProvider } from '@/libraries/contexts/floating-portal-context';
import styles from './search-widget-modal.module.scss';

export interface SearchWidgetModalProps extends Omit<ModalProps, 'children'> {
  /** Default values for the search bar*/
  defaultValues?: SearchBarDefaultValues;
  /** Search settings for the search bar */
  searchSettings: Content.Components['SearchSettingsDto'];
}

const SearchWidgetModal = ({
  defaultValues,
  isOpen,
  searchSettings,
  setIsOpen,
  ...rest
}: SearchWidgetModalProps) => {
  const curtainRef = useRef<HTMLDivElement>(null);

  if (!isOpen) return null;

  return (
    <Modal
      {...rest}
      className={styles.component}
      isOpen={isOpen}
      onClickOutside={() => setIsOpen?.(false)}
      setIsOpen={setIsOpen}
    >
      <FloatingPortalProvider getPortalElement={() => curtainRef.current}>
        <div ref={curtainRef} className={styles.curtain}>
          <SearchBar
            isWidget
            propDefaultValues={defaultValues}
            searchSettings={searchSettings}
            shouldRefresh
          />
        </div>
      </FloatingPortalProvider>
    </Modal>
  );
};

SearchWidgetModal.displayName = 'SearchWidgetModal';

export default SearchWidgetModal;
